import { render, staticRenderFns } from "./LocalTurnsView.vue?vue&type=template&id=8742d6c6&"
import script from "./LocalTurnsView.vue?vue&type=script&lang=js&"
export * from "./LocalTurnsView.vue?vue&type=script&lang=js&"
import style0 from "./LocalTurnsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports